<div class="mt-4">
  <p-panel header="Página" [toggleable]="true" [toggler]="'header'" styleClass="mb-3">
  <div class="flex flex-column mb-4">
    <div class="flex flex-column" [ngClass]="{ 'mb-0': ctrl.selectedPageType !== 'outras' && ctrl.selectedPageType !== 'homepage' }">
      <label for="pageTypeSelect" class="w-full ss-g-globalClassLabel">
        Tipo de Página
      </label>
      <p-dropdown
        [options]="ctrl.pageTypes"
        appendTo="body"
        [(ngModel)]="ctrl.selectedPageType"
        placeholder="Selecione um tipo de página"
        (ngModelChange)="ctrl.onPageTypeChange($event)">
      </p-dropdown>
    </div>

    <div
      class="card shadow-none upload-placeholder mt-2 mb-0 p-4 cursor-pointer"
      [ngStyle]="!ctrl.selectedProduct && !ctrl.selectedCollection && !ctrl.selectedArticle ? {'border-style': 'dashed', 'border-width': '2px'} : {}"
      [ngClass]="{'ng-invalid': ctrl.hasErrorUrlDisplay, 'ng-dirty': ctrl.hasErrorUrlDisplay}"
      *ngIf="ctrl.selectedPageType !== 'outras' && ctrl.selectedPageType !== 'homepage'"
      (click)="ctrl.handleOpenList()">

      <ng-container
        *ngIf="ctrl.selectedPageType === 'produtos' && ctrl.selectedProduct && ctrl.showSearchButton; else uploadIcon">
        <div class="selected-product flex flex-column gap-2 w-full">
          <div class="flex align-items-center gap-3 w-full">
            <img [src]="ctrl.selectedProduct.thumbnail" alt="Imagem do Produto"
              class="selected-product-thumbnail border-round-md"
              style="width: 60px; height: 60px; object-fit: cover;">
            <div class="m-0 font-bold">{{ ctrl.selectedProduct.title }}</div>
          </div>

          <div class="flex align-items-center justify-content-between w-full product-details">
            <p class="m-0"
              style="max-width: 85%; overflow-wrap: break-word; word-break: break-word; overflow: hidden;">
              {{ ctrl.selectedProduct.displayUrl || '' }}
            </p>
            <button pButton pRipple icon="pi pi-trash" class="p-button-danger p-button-sm"
              (click)="ctrl.clearSelection($event)"></button>
          </div>
        </div>
      </ng-container>

      <ng-container
        *ngIf="ctrl.selectedPageType === 'colecoes' && ctrl.selectedCollection && ctrl.showSearchButton">
        <div class="selected-product flex flex-column gap-2 w-full">
          <div class="flex align-items-center gap-3 w-full">
            <img [src]="ctrl.selectedCollection.image" alt="Imagem da Coleção"
              class="selected-product-thumbnail border-round-md"
              style="width: 60px; height: 60px; object-fit: cover;">
            <div class="m-0 font-bold">{{ ctrl.selectedCollection.title }}</div>
          </div>

          <div class="flex align-items-center justify-content-between w-full product-details">
            <p class="m-0"
              style="max-width: 85%; overflow-wrap: break-word; word-break: break-word; overflow: hidden;">
              {{ ctrl.selectedCollection.displayUrl || '' }}
            </p>
            <button pButton pRipple icon="pi pi-trash" class="p-button-danger p-button-sm"
              (click)="ctrl.clearSelection($event)"></button>
          </div>
        </div>
      </ng-container>

      <ng-container *ngIf="ctrl.selectedPageType === 'artigos' && ctrl.selectedArticle && ctrl.showSearchButton">
        <div class="selected-product flex flex-column gap-2 w-full">
          <div class="flex align-items-center gap-3 w-full">
            <img [src]="ctrl.selectedArticle.image" alt="Imagem do Artigo"
              class="selected-product-thumbnail border-round-md"
              style="width: 60px; height: 60px; object-fit: cover;">
            <div class="m-0 font-bold">{{ ctrl.selectedArticle.title }}</div>
          </div>

          <div class="flex align-items-center justify-content-between w-full product-details">
            <p class="m-0"
              style="max-width: 85%; overflow-wrap: break-word; word-break: break-word; overflow: hidden;">
              {{ ctrl.selectedArticle.displayUrl || '' }}
            </p>
            <button pButton pRipple icon="pi pi-trash" class="p-button-danger p-button-sm"
              (click)="ctrl.clearSelection($event)"></button>
          </div>
        </div>
      </ng-container>

      <ng-template #uploadIcon>
        <ng-container *ngIf="!ctrl.selectedProduct && !ctrl.selectedCollection && !ctrl.selectedArticle">
          <div class="flex flex-column align-items-center justify-content-center text-center">
            <i class="pi pi-upload text-2xl mb-2 text-surface-900 dark:text-surface-0"></i>
            <span class="text-sm text-surface-700 dark:text-surface-200">
              {{
              ctrl.selectedPageType === 'produtos' ? 'Selecionar Produto' :
              ctrl.selectedPageType === 'colecoes' ? 'Selecionar Coleção' :
              ctrl.selectedPageType === 'artigos' ? 'Selecionar Artigo' : ''
              }}
            </span>
          </div>
        </ng-container>
      </ng-template>
    </div>

    <div class="flex align-items-center justify-content-between">
      <small *ngIf="ctrl.hasErrorUrlDisplay" class="p-error">
        Esta URL já está sendo usada por outro widget.
      </small>
    </div>
  </div>

  <div class="flex flex-column mb-4"
    *ngIf="ctrl.selectedTemplate === 'carousel' || ctrl.selectedTemplate === 'grid' || ctrl.selectedTemplate === 'iframe' || ctrl.selectedTemplate === 'inline' || ctrl.selectedTemplate === 'stories'">

    <p class="mt-2 mb-2"><b>Adicione o widget às páginas</b></p>
    <p class="mb-2">Adicione o script abaixo na parte do seu site que gostaria de exibir se widget.</p>

    <div class="mt-2 mb-2">
      <label for="pageTypeSelect" class="w-full ss-g-globalClassLabel"
        *ngIf="ctrl.selectedPageType == 'outras'">
        Widget ID
      </label>
      <div class="p-inputgroup ss-g-custom-inputgroup mt-2" *ngIf="ctrl.selectedPageType == 'outras'">
        <input type="text" pInputText [(ngModel)]="ctrl.widget_id" readonly class="custom-input">
        <button pButton pRipple type="button" icon="pi pi-copy" (click)="ctrl.copiarWidget()"
          class="ss-l-custom-button"></button>
      </div>
    </div>

    <div class="mt-2 mb-2">
      <button pButton class="w-full" label="Adicionar widget" (click)="ctrl.openShopifyThemeEditor()"
        [disabled]="!ctrl.hasSelectedPageItem">
      </button>
    </div>

    <div class="mt-2" *ngIf="ctrl.selectedTemplate === 'iframe'"><b>Obs.:</b> É preciso definir largura e altura para este formato</div>
  </div>
  <div class="flex flex-column mb-4"
    *ngIf="ctrl.selectedTemplate === 'discover'">
    <div class="mt-2 mb-2">
      <button pButton class="w-full" label="Adicionar widget" (click)="ctrl.openShopifyThemeEditor()"
        [disabled]="!ctrl.hasSelectedPageItem || !ctrl.storeEditToken">
      </button>
    </div>
  </div>
  <div class="flex flex-column mb-4"
    *ngIf="ctrl.selectedTemplate !== 'iframe' && ctrl.selectedPageType == 'outras'">
    <p class="mt-0 mb-0">
      <b>Defina em quais páginas exibir o widget</b>
    </p>
    <p>Defina as URLs ou regras para exibição do widget em suas páginas.</p>

    <!-- Rule-builder: grupos aninhados com AND/OR, condições Igual/Contém -->
    <app-rule-group [group]="ctrl.ruleTree"></app-rule-group>
  </div>

  <div class="flex flex-column mb-4" *ngIf="ctrl.selectedTemplate === 'iframe'">
    <p>
      <b>Passo 2 - </b> Para garantir que o iFrame funcione em sua página ou aplicação,
      certifique-se de que seu domínio já foi incluído em:
    </p>
    <p-breadcrumb [model]="ctrl.breadcrumbItems"></p-breadcrumb>
  </div>
  </p-panel>

  <p-panel header="Devices" [toggleable]="true" [toggler]="'header'" styleClass="mb-3" [collapsed]="true"
    *ngIf="ctrl.selectedTemplate !== 'iframe'">
    <div class="flex align-items-center mb-2">
      <p-inputSwitch [(ngModel)]="ctrl.showSmartphones" (onChange)="ctrl.onSwitchChangeMobile($event)"
        class="mr-2"></p-inputSwitch>
      <label>Exibir em <b>Smartphones</b></label>
    </div>

    <div class="flex align-items-center">
      <p-inputSwitch [(ngModel)]="ctrl.showDesktops" (onChange)="ctrl.onSwitchChangeDesktop($event)"
        class="mr-2"></p-inputSwitch>
      <label>Exibir em <b>Desktops</b></label>
    </div>
  </p-panel>

  <p-panel header="Título" [toggleable]="true" [toggler]="'header'" styleClass="mb-3" [collapsed]="true"
    *ngIf="ctrl.integrationPlatform !== 'shopify' && ctrl.selectedTemplate !== 'iframe' && ctrl.selectedTemplate !== 'popup'">
    <div class="flex align-items-center" [ngClass]="ctrl.showWidgetTitle ? 'mb-2' : ''">
      <p-inputSwitch [(ngModel)]="ctrl.showWidgetTitle" (onChange)="ctrl.editWidget(0)" class="mr-2"></p-inputSwitch>
      <label>Exibir <b>título</b> no widget</label>
    </div>

    <ng-container *ngIf="ctrl.showWidgetTitle">
      <div class="mb-3">
        <label class="w-full ss-g-globalClassLabel">Tamanho do título
          <div class="mt-2">
            <p-dropdown
              [options]="ctrl.titleTagOptions"
              [(ngModel)]="ctrl.widgetTitleTag"
              optionLabel="label"
              optionValue="value"
              appendTo="body"
              class="w-full"
              (ngModelChange)="ctrl.editWidget(0)">
            </p-dropdown>
          </div>
        </label>
      </div>

      <div class="mb-3" *ngIf="ctrl.nuvemshopStyledTemplates.includes(ctrl.selectedTemplate)">
        <label class="w-full ss-g-globalClassLabel">Alinhamento do título
          <div class="mt-2">
            <p-selectButton
              [options]="ctrl.titleAlignmentOptions"
              [(ngModel)]="ctrl.titleAlignment"
              optionLabel="label"
              optionValue="value"
              class="w-full ss-g-align-select-button"
              (onChange)="ctrl.editWidget(0)">
              <ng-template let-item pTemplate="item">
                <i [class]="item.icon" [pTooltip]="item.label" tooltipPosition="top"></i>
              </ng-template>
            </p-selectButton>
          </div>
        </label>
      </div>

      <div *ngIf="ctrl.nuvemshopStyledTemplates.includes(ctrl.selectedTemplate)">
        <label class="w-full ss-g-globalClassLabel">Espaço abaixo do título
          <div class="mt-2 p-fluid">
            <p-inputNumber [(ngModel)]="ctrl.titleSpacing" suffix=" px" [min]="0" [max]="80" [step]="4"
              [showButtons]="true" buttonLayout="horizontal" incrementButtonIcon="pi pi-plus" decrementButtonIcon="pi pi-minus"
              class="w-full" (onBlur)="ctrl.editWidget(0)"></p-inputNumber>
          </div>
        </label>
      </div>
    </ng-container>
  </p-panel>

  <p-panel [toggleable]="true" [toggler]="'header'" styleClass="mb-3" [collapsed]="true"
    *ngIf="ctrl.integrationPlatform !== 'shopify' && ctrl.nuvemshopStyledTemplates.includes(ctrl.selectedTemplate)">
    <ng-template pTemplate="header">
      <div class="flex align-items-center gap-2 w-full">
        <span class="ss-g-globalClassLabel ss-l-spacing-panel-label text-lg font-semibold">Espaçamento</span>
        <i class="pi" [ngClass]="ctrl.isEditingMobileSpacing ? 'pi-mobile' : 'pi-desktop'"
          [pTooltip]="ctrl.isEditingMobileSpacing ? 'Editando: Mobile' : 'Editando: Desktop'" tooltipPosition="top"></i>
      </div>
    </ng-template>
    <div class="pb-3 mb-3 border-bottom-1 surface-border">
      <div class="flex align-items-center justify-content-between mb-4">
        <label class="ss-g-globalClassLabel text-lg m-0">Padding horizontal</label>
        <p-selectButton [options]="ctrl.spacingUnitOptions" [(ngModel)]="ctrl.paddingUnit" optionLabel="label"
          optionValue="value" (onChange)="ctrl.scheduleAutoSave()" styleClass="ss-l-unit-selectbutton"></p-selectButton>
      </div>
      <div class="flex align-items-end gap-2">
        <div class="flex-1 p-fluid">
          <label class="w-full ss-g-globalClassLabel block mb-2">Esquerda</label>
          <p-inputNumber [ngModel]="ctrl.effectivePaddingLeft" (ngModelChange)="ctrl.onPaddingChange('X', 'first', $event)"
            [suffix]="' ' + ctrl.paddingUnit" [min]="ctrl.paddingUnitConfig.min" [max]="ctrl.paddingUnitConfig.max"
            [step]="ctrl.paddingUnitConfig.step" [maxFractionDigits]="ctrl.paddingUnitConfig.maxFractionDigits"
            [showButtons]="true" buttonLayout="horizontal"
            incrementButtonIcon="pi pi-plus" decrementButtonIcon="pi pi-minus" class="w-full"></p-inputNumber>
        </div>
        <button pButton pRipple type="button" icon="pi pi-link" class="ss-l-anchor-btn p-button-sm p-button-secondary flex-shrink-0"
          [ngClass]="!ctrl.linkPaddingX ? 'p-button-outlined' : ''" (click)="ctrl.toggleLinkPadding('X')"
          [pTooltip]="ctrl.linkPaddingX ? 'Valores vinculados — clique para tornar independentes' : 'Valores independentes — clique para vincular'"></button>
        <div class="flex-1 p-fluid">
          <label class="w-full ss-g-globalClassLabel block mb-2">Direita</label>
          <p-inputNumber [ngModel]="ctrl.effectivePaddingRight" (ngModelChange)="ctrl.onPaddingChange('X', 'second', $event)"
            [suffix]="' ' + ctrl.paddingUnit" [min]="ctrl.paddingUnitConfig.min" [max]="ctrl.paddingUnitConfig.max"
            [step]="ctrl.paddingUnitConfig.step" [maxFractionDigits]="ctrl.paddingUnitConfig.maxFractionDigits"
            [showButtons]="true" buttonLayout="horizontal"
            incrementButtonIcon="pi pi-plus" decrementButtonIcon="pi pi-minus" class="w-full"></p-inputNumber>
        </div>
      </div>
    </div>

    <div class="pb-3 mb-3 border-bottom-1 surface-border">
      <label class="w-full ss-g-globalClassLabel mb-4 block text-lg">Padding vertical</label>
      <div class="flex align-items-end gap-2">
        <div class="flex-1 p-fluid">
          <label class="w-full ss-g-globalClassLabel block mb-2">Topo</label>
          <p-inputNumber [ngModel]="ctrl.effectivePaddingTop" (ngModelChange)="ctrl.onPaddingChange('Y', 'first', $event)"
            [suffix]="' ' + ctrl.paddingUnit" [min]="ctrl.paddingUnitConfig.min" [max]="ctrl.paddingUnitConfig.max"
            [step]="ctrl.paddingUnitConfig.step" [maxFractionDigits]="ctrl.paddingUnitConfig.maxFractionDigits"
            [showButtons]="true" buttonLayout="horizontal"
            incrementButtonIcon="pi pi-plus" decrementButtonIcon="pi pi-minus" class="w-full"></p-inputNumber>
        </div>
        <button pButton pRipple type="button" icon="pi pi-link" class="ss-l-anchor-btn p-button-sm p-button-secondary flex-shrink-0"
          [ngClass]="!ctrl.linkPaddingY ? 'p-button-outlined' : ''" (click)="ctrl.toggleLinkPadding('Y')"
          [pTooltip]="ctrl.linkPaddingY ? 'Valores vinculados — clique para tornar independentes' : 'Valores independentes — clique para vincular'"></button>
        <div class="flex-1 p-fluid">
          <label class="w-full ss-g-globalClassLabel block mb-2">Base</label>
          <p-inputNumber [ngModel]="ctrl.effectivePaddingBottom" (ngModelChange)="ctrl.onPaddingChange('Y', 'second', $event)"
            [suffix]="' ' + ctrl.paddingUnit" [min]="ctrl.paddingUnitConfig.min" [max]="ctrl.paddingUnitConfig.max"
            [step]="ctrl.paddingUnitConfig.step" [maxFractionDigits]="ctrl.paddingUnitConfig.maxFractionDigits"
            [showButtons]="true" buttonLayout="horizontal"
            incrementButtonIcon="pi pi-plus" decrementButtonIcon="pi pi-minus" class="w-full"></p-inputNumber>
        </div>
      </div>
    </div>

    <div class="pb-3 mb-3 border-bottom-1 surface-border">
      <div class="flex align-items-center justify-content-between mb-4">
        <label class="ss-g-globalClassLabel text-lg m-0">Margin horizontal</label>
        <p-selectButton [options]="ctrl.spacingUnitOptions" [(ngModel)]="ctrl.marginUnit" optionLabel="label"
          optionValue="value" (onChange)="ctrl.scheduleAutoSave()" styleClass="ss-l-unit-selectbutton"></p-selectButton>
      </div>
      <div class="flex align-items-end gap-2">
        <div class="flex-1 p-fluid">
          <label class="w-full ss-g-globalClassLabel block mb-2">Esquerda</label>
          <p-inputNumber [ngModel]="ctrl.effectiveMarginLeft" (ngModelChange)="ctrl.onMarginChange('X', 'first', $event)"
            [suffix]="' ' + ctrl.marginUnit" [min]="ctrl.marginUnitConfig.min" [max]="ctrl.marginUnitConfig.max"
            [step]="ctrl.marginUnitConfig.step" [maxFractionDigits]="ctrl.marginUnitConfig.maxFractionDigits"
            [showButtons]="true" buttonLayout="horizontal"
            incrementButtonIcon="pi pi-plus" decrementButtonIcon="pi pi-minus" class="w-full"></p-inputNumber>
        </div>
        <button pButton pRipple type="button" icon="pi pi-link" class="ss-l-anchor-btn p-button-sm p-button-secondary flex-shrink-0"
          [ngClass]="!ctrl.linkMarginX ? 'p-button-outlined' : ''" (click)="ctrl.toggleLinkMargin('X')"
          [pTooltip]="ctrl.linkMarginX ? 'Valores vinculados — clique para tornar independentes' : 'Valores independentes — clique para vincular'"></button>
        <div class="flex-1 p-fluid">
          <label class="w-full ss-g-globalClassLabel block mb-2">Direita</label>
          <p-inputNumber [ngModel]="ctrl.effectiveMarginRight" (ngModelChange)="ctrl.onMarginChange('X', 'second', $event)"
            [suffix]="' ' + ctrl.marginUnit" [min]="ctrl.marginUnitConfig.min" [max]="ctrl.marginUnitConfig.max"
            [step]="ctrl.marginUnitConfig.step" [maxFractionDigits]="ctrl.marginUnitConfig.maxFractionDigits"
            [showButtons]="true" buttonLayout="horizontal"
            incrementButtonIcon="pi pi-plus" decrementButtonIcon="pi pi-minus" class="w-full"></p-inputNumber>
        </div>
      </div>
    </div>

    <div>
      <label class="w-full ss-g-globalClassLabel mb-4 block text-lg">Margin vertical</label>
      <div class="flex align-items-end gap-2">
        <div class="flex-1 p-fluid">
          <label class="w-full ss-g-globalClassLabel block mb-2">Topo</label>
          <p-inputNumber [ngModel]="ctrl.effectiveMarginTop" (ngModelChange)="ctrl.onMarginChange('Y', 'first', $event)"
            [suffix]="' ' + ctrl.marginUnit" [min]="ctrl.marginUnitConfig.min" [max]="ctrl.marginUnitConfig.max"
            [step]="ctrl.marginUnitConfig.step" [maxFractionDigits]="ctrl.marginUnitConfig.maxFractionDigits"
            [showButtons]="true" buttonLayout="horizontal"
            incrementButtonIcon="pi pi-plus" decrementButtonIcon="pi pi-minus" class="w-full"></p-inputNumber>
        </div>
        <button pButton pRipple type="button" icon="pi pi-link" class="ss-l-anchor-btn p-button-sm p-button-secondary flex-shrink-0"
          [ngClass]="!ctrl.linkMarginY ? 'p-button-outlined' : ''" (click)="ctrl.toggleLinkMargin('Y')"
          [pTooltip]="ctrl.linkMarginY ? 'Valores vinculados — clique para tornar independentes' : 'Valores independentes — clique para vincular'"></button>
        <div class="flex-1 p-fluid">
          <label class="w-full ss-g-globalClassLabel block mb-2">Base</label>
          <p-inputNumber [ngModel]="ctrl.effectiveMarginBottom" (ngModelChange)="ctrl.onMarginChange('Y', 'second', $event)"
            [suffix]="' ' + ctrl.marginUnit" [min]="ctrl.marginUnitConfig.min" [max]="ctrl.marginUnitConfig.max"
            [step]="ctrl.marginUnitConfig.step" [maxFractionDigits]="ctrl.marginUnitConfig.maxFractionDigits"
            [showButtons]="true" buttonLayout="horizontal"
            incrementButtonIcon="pi pi-plus" decrementButtonIcon="pi pi-minus" class="w-full"></p-inputNumber>
        </div>
      </div>
    </div>
  </p-panel>
</div>
